export enum MeshesTabTypes {
  meshes = 'meshes',
  materials = 'materials',
  groups = 'groups',
}
